import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { signUp, token_status } from "./signupAPI";

// Initial state
const initialState = {
  loading: false,
  success: false,
  user: null,
  page: 0,
  data: null,
};

const actions = {
  SIGNUP: "signup/SIGNUP",
  TOKEN_STATUS: "tokenStatus/TOKEN_STATUS",
};

// Async thunk for sign-up
export const signup = createAsyncThunk(actions.SIGNUP, async (payload, { rejectWithValue }) => {
  try {
    const response = await signUp(payload);
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Signup failed" });
  }
});

// Async thunk for token status
export const token = createAsyncThunk(actions.TOKEN_STATUS, async (payload, { rejectWithValue }) => {
  try {
    const response = await token_status(payload);
    return response;
  } catch (error) {
    return rejectWithValue(error.response?.data || { message: "Token check failed" });
  }
});

// Slice
export const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {
    resetSignUpDetails: (state) => {
      state.success = false;
      state.user = null;
      state.page = 0;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Signup cases
      .addCase(signup.pending, (state) => {
        state.loading = true;
      })
      .addCase(signup.fulfilled, (state, action) => {
        const { success, message: msg, result, user, is_domestic } = action.payload;
        state.loading = false;
        state.success = success;
        state.data = result || null;
        state.user = user || null;

        if (success) {
          state.page = result ? 2 : 1;
          message.success(msg);
        } else {
          message.error(msg);
        }
      })
      .addCase(signup.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        message.error(action.payload?.message || "Signup failed");
      })

      // Token cases
      .addCase(token.pending, (state) => {
        state.loading = true;
      })
      .addCase(token.fulfilled, (state, action) => {
        const { success, message: msg } = action.payload;
        state.loading = false;

        if (!success) {
          message.error(msg);
        }
      })
      .addCase(token.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        message.error(action.payload?.message || "Token validation failed");
      });
  },
});

export const { resetSignUpDetails } = signupSlice.actions;
export default signupSlice.reducer;